module.exports = __webpack_public_path__ + "static/media/eye-on.5022405a.svg";